const SCHEDULED_PAYMENT_TYPES = new Set<string>(["split_50_50", "pay_later"]);

/**
 * Minimal master-contract fields needed to decide whether a booking is
 * actually on a payment schedule. Quotes/contracts often still carry
 * `split_payment` amounts when the guest paid in full.
 *
 * Values are `unknown` so offer-quote masters — which reach us through an
 * index signature — satisfy this alongside typed `MasterContract`s.
 */
type MasterPaymentScheduleFields = {
  payment_schedule_type?: unknown;
  split_payment_checkout?: unknown;
};

/**
 * True when the master contract is on a real payment schedule
 * (`split_50_50` / `pay_later`, or the legacy `split_payment_checkout` flag).
 */
const hasScheduledPayment = (
  masterContract: MasterPaymentScheduleFields | null | undefined,
): boolean => {
  const scheduleType = masterContract?.payment_schedule_type;
  // Backwards compatibility: check old split_payment_checkout flag
  if (scheduleType == null && masterContract?.split_payment_checkout === true) {
    return true;
  }
  return (
    typeof scheduleType === "string" &&
    SCHEDULED_PAYMENT_TYPES.has(scheduleType)
  );
};

export type { MasterPaymentScheduleFields };
export { hasScheduledPayment };
